export default __webpack_public_path__ + "static/media/Kristianstad_full.7862849c.png";